import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Section, Container, RichText, BtnPrimary } from '../styles/shared';
import { resolveMediaServeUrl } from '../utils/mediaServeUrls';

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ $left }) => $left}fr ${({ $right }) => $right}fr;
  gap: 48px;
  align-items: ${({ $valign }) => $valign || 'center'};
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const ImgWrap = styled.div`
  img {
    width: 100%; height: auto; border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  }
`;

const ContentWrap = styled.div`
  display: flex; flex-direction: column; justify-content: center;
`;

const CTA = styled.div` margin-top: 24px; `;

const TwoColumnBlock = ({ content = {}, settings = {}, tenantSlug, apiBase }) => {
  const {
    // schema-aligned field names
    content: textContent = '',
    image: imageUrl = '',
    // legacy field names (backwards compat)
    leftContent = '', rightContent = '',
    leftImage = '', rightImage = '',
    imagePosition = 'right', splitRatio = '50-50',
    verticalAlign = 'center',
    button = {}, buttonText = '', buttonLink = ''
  } = content;
  const { backgroundColor = '', padding = 'large' } = settings;

  const resolvedImage   = resolveMediaServeUrl(imageUrl || leftImage || rightImage || '', tenantSlug, apiBase)
    || imageUrl || leftImage || rightImage || '';
  const resolvedText    = textContent || leftContent || rightContent || '';
  const resolvedBtnText = button.text || buttonText || '';
  const resolvedBtnLink = button.link || buttonLink || '';
  const [lw, rw] = splitRatio.split('-').map(Number);

  const imgEl = resolvedImage ? <ImgWrap><img src={resolvedImage} alt="" loading="lazy" /></ImgWrap> : null;
  const textEl = (
    <ContentWrap>
      <RichText dangerouslySetInnerHTML={{ __html: resolvedText }} />
      {resolvedBtnText && resolvedBtnLink && (
        <CTA>
          <BtnPrimary as={Link} to={resolvedBtnLink}>{resolvedBtnText}</BtnPrimary>
        </CTA>
      )}
    </ContentWrap>
  );

  return (
    <Section $padding={padding} $bgColor={backgroundColor}>
      <Container>
        <Grid $left={lw / 100} $right={rw / 100} $valign={verticalAlign}>
          <div>{imagePosition === 'left' ? (imgEl || textEl) : textEl}</div>
          <div>{imagePosition === 'left' ? textEl : (imgEl || textEl)}</div>
        </Grid>
      </Container>
    </Section>
  );
};

export default TwoColumnBlock;
